import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import type { ChannelState } from '../types/channel';

export const useChannelStore = create<ChannelState>()(
  devtools(
    persist(
      set => ({
        channel: null,
        setChannel: channel => set({ channel }, false, 'setChannel'),
      }),
      {
        name: 'channel-storage',
        partialize: state => ({ channel: state.channel }),
      },
    ),
    { name: 'ChannelStore' },
  ),
);
